import type { ResponseClustering } from '@mentimeter/http-clients';

export const testGroupedResponses: ResponseClustering = {
  id: '1',
  status: 'complete',
  score: 0,
  unclustered_responses: [],
  clusters: [
    {
      id: 'cluster-1',
      clustering_id: '1',
      label: 'Be yourself',
      total_upvotes: 0,
      responses: [
        {
          id: '1',
          text: 'Be the change that you wish to see in the world.',
          cluster_id: 'cluster-1',
          upvotes: 0,
        },
        {
          id: '2',
          text: 'Be yourself; everyone else is already taken.',
          cluster_id: 'cluster-1',
          upvotes: 0,
        },
        {
          id: '3',
          text: 'No one can make you feel inferior without your consent.',
          cluster_id: 'cluster-1',
          upvotes: 0,
        },
      ],
    },
    {
      id: 'cluster-2',
      clustering_id: '1',
      label: 'No excuses',
      total_upvotes: 0,
      responses: [
        {
          id: '4',
          text: 'Whether you think you can or you think you can’t, you’re right.',
          cluster_id: 'cluster-2',
          upvotes: 0,
        },
        {
          id: '5',
          text: 'Do, or do not. There is no "try".',
          cluster_id: 'cluster-2',
          upvotes: 0,
        },
        {
          id: '6',
          text: 'I attribute my success to this: I never gave or took any excuse.',
          cluster_id: 'cluster-2',
          upvotes: 0,
        },
      ],
    },
    {
      id: 'cluster-3',
      clustering_id: '1',
      label: 'Love and be loved',
      total_upvotes: 0,
      responses: [
        {
          id: '7',
          text: 'The greatest thing you will ever learn is just to love and be loved in return.',
          cluster_id: 'cluster-3',
          upvotes: 0,
        },
        {
          id: '8',
          text: 'Life is what happens to you while you’re busy making other plans.',
          cluster_id: 'cluster-3',
          upvotes: 0,
        },
      ],
    },
    {
      id: 'cluster-4',
      clustering_id: '1',
      label: 'Give and be',
      total_upvotes: 0,
      responses: [
        {
          id: '9',
          text: 'I have seen the best of you, and the worst of you, and I choose both.',
          cluster_id: 'cluster-4',
          upvotes: 0,
        },
        {
          id: '10',
          text: 'Life isn’t about getting and having, it’s about giving and being.',
          cluster_id: 'cluster-4',
          upvotes: 0,
        },
      ],
    },
    {
      id: 'cluster-5',
      clustering_id: '1',
      label: 'Define yourself',
      total_upvotes: 0,
      responses: [
        {
          id: '11',
          text: "What defines you isn't how many times you crash but the number of times you get back.",
          cluster_id: 'cluster-5',
          upvotes: 0,
        },
      ],
    },
    {
      id: 'cluster-6',
      clustering_id: '1',
      label: 'Take shots',
      total_upvotes: 0,
      responses: [
        {
          id: '12',
          text: 'You miss 100% of the shots you don’t take.',
          cluster_id: 'cluster-6',
          upvotes: 0,
        },
      ],
    },
    {
      id: 'cluster-7',
      clustering_id: '1',
      label: 'Plant a tree',
      total_upvotes: 0,
      responses: [
        {
          id: '13',
          text: 'The best time to plant a tree was 20 years ago. The second best time is now.',
          cluster_id: 'cluster-7',
          upvotes: 0,
        },
      ],
    },
    {
      id: 'cluster-8',
      clustering_id: '1',
      total_upvotes: 0,
      label: 'Show up',
      responses: [
        {
          id: '14',
          text: 'Eighty percent of success is showing up.',
          cluster_id: 'cluster-8',
          upvotes: 0,
        },
      ],
    },
    {
      id: 'cluster-9',
      clustering_id: '1',
      label: 'Find your why',
      total_upvotes: 0,
      responses: [
        {
          id: '15',
          text: 'The two most important days in your life are the day you are born and the day you find out why.',
          cluster_id: 'cluster-9',
          upvotes: 0,
        },
      ],
    },
    {
      id: 'cluster-10',
      clustering_id: '1',
      label: 'Courage',
      total_upvotes: 0,
      responses: [
        {
          id: '16',
          text: 'Life shrinks or expands in proportion to one’s courage.',
          cluster_id: 'cluster-10',
          upvotes: 0,
        },
      ],
    },
  ],
};
